import { createSelector } from '@reduxjs/toolkit'
import { cartSlice } from '..'

export const otherReservationsSelectors = createSelector(
  [
    cartSlice.selectors.cartReservations,
    cartSlice.selectors.selectedElementReservation,
  ],
  (cartReservations, selectedElementReservation) => {
    if (!selectedElementReservation) {
      return []
    }

    return cartReservations.filter((cr) => {
      if (cr.spotType !== selectedElementReservation.spotType) {
        return true
      }

      return cr.spotName !== selectedElementReservation.spotName
    })
  }
)
